import { ERROR_MESSAGES } from '@/utils/defaultErrorMsg'
import { validateEmail, validateName, validatePhone } from '@/utils/validations'
import { z } from 'zod'

export const minorAccessRequestSchema = z.object({
  guardianName: z.string().refine(
    value => {
      return validateName(value)
    },
    { message: ERROR_MESSAGES.INVALID_NAME },
  ),
  guardianKinship: z
    .object({
      key: z.string(),
      value: z.string(),
    })
    .refine(data => data.key.length > 0, {
      message: ERROR_MESSAGES.REQUIRED_FIELD,
    }),
  guardianEmail: z.string().refine(
    value => {
      return validateEmail(value)
    },
    { message: ERROR_MESSAGES.INVALID_EMAIL },
  ),
  guardianCellphone: z.string().refine(
    value => {
      return validatePhone(value)
    },
    { message: ERROR_MESSAGES.INVALID_CELLPHONE },
  ),
})
